import { supabase } from './supabase/supabaseClient.js';

export async function getConversaciones(canal) {
  let query = supabase
    .schema('messaging')
    .from('conversaciones')
    .select('id, canal, contact_address, status, last_message_at')
    .order('last_message_at', { ascending: false });
  if (canal) query = query.eq('canal', canal);
  const { data, error } = await query;
  if (error) throw new Error(error.message);
  return data ?? [];
}

export async function getMensajesDeConversacion(conversacionId) {
  const { data, error } = await supabase
    .schema('messaging')
    .from('mensajes')
    .select('id, direction, content, status, created_at, from_address')
    .eq('conversacion_id', conversacionId)
    .order('created_at', { ascending: true });
  if (error) throw new Error(error.message);
  return data ?? [];
}
